<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <!-- <a-spin :spinning="spinning" size="large"/> -->
      <router-view />
    </div>
  </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data () {
    return {
      locale: zhCN
    }
  },
  computed: {
    spinning () {
      return this.$store.state.spinning
    }
  },
  mounted () {
    let keytype = this.listAjax('keytype')
    let flag = false
    if(window.location.hash.concat('wjRepair')){
      flag = true
    }
    if (keytype && keytype !== '') {
      this.$store.state.keytype = keytype
    }
    if (this.$store.state.keytype !== 'mhtz' && !flag) {
      this.$axios.post('/api/roleMenu/getRoles.do', { op: 'cnm' }).then(res => {
        if (!res.data.roles[0]) {
          this.$router.push({ path: '/403', query: {} })
        } else {
          this.$store.userinfo = res.data.roles[0]
          if (res.data.roles[0].code === 'BXXT_WYRY' && this.$route.path !== '/apply') {
            this.$router.push({ path: '/myrepair', query: {} })
          }
        }
      })
    }
    // 修复IE不跳转路由的问题
    function checkIE () {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  methods: {
    // 获取url参数
    listAjax (name) {
      let reg = new RegExp('[?|&]' + name + '=([^&]*)(&|$)')
      let r = (decodeURI(window.location.hash || window.location.search)).substr(1).match(reg)
      if (r !== null) return unescape(r[1])
      return null
    }
  }
}
</script>
